import React, { useEffect, useState } from 'react';
import { Card } from '@material-ui/core';
import AppBar from '@common/AppBar2';
import CommonForm from '@common/CommonForm2';
import { Actions, Constants } from '@data'

const action = new Actions();

export default function Close({
  language,
  values,
  options,
  contracts,
  setFormReference,
  handleValue,
  setValue,
}) {

  const [catalogOptions, setCatalogOptions] = useState([])
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [taskOptions, setTaskOptions] = useState([]);

  function getCatalogByCategory(categoryId) {
    return action.execute('get', Constants.APIEndpoints.CATALOG + '/company/' + values.fk_id_company + '/' + categoryId, '')
    .then(res => {
      const catalog = res.data.map(c => ({ value: c.id_catalog_service, label: c.name, task: c.task }))
      setCatalogOptions(catalog)
    })
  }

  function getCategoryByCompany(companyId) {
    return action.execute('get', Constants.APIEndpoints.CATEGORY + '/company/' + companyId, '').then((b) => {
      setCategoriesOptions(b.data);
      const hasCategory = b.data.find((e) => e.id_category == values.fk_id_category)
      if (!hasCategory) {
        setValue('fk_id_category', null);
        handleValue(null, 'fk_id_category')
      }
    });
  };

  function buildTaskOptions(catalogServiceId) {
    const taskOptionsByCatalog = catalogOptions.find((e) => e.value == catalogServiceId);
    if (taskOptionsByCatalog) {
      setTaskOptions(taskOptionsByCatalog.task?.map((t) => ({ value: t.id_catalog_task, label: t.name })));
    }
  }

  useEffect(() => {
    if (values?.fk_id_category){
      getCatalogByCategory(values.fk_id_category);
    }
  }, [values.fk_id_category]);

  useEffect(() => {
    if (values?.fk_id_company && (!catalogOptions || !catalogOptions.length)) {
      getCatalogByCategory(values.fk_id_category).then(() => {
        buildTaskOptions(values.fk_id_catalog_service);
      })
    } else {
      buildTaskOptions(values.fk_id_catalog_service);
    }
  }, [values.fk_id_catalog_service, catalogOptions]);

  function loadFields(){

    let fields = [
      {
        col: 4,
        type: 'select',
        name: 'type_category',
        label: 'Item',
        options: options.type_category(values?.rule),
        required: true,
      },
    ];

    if(values?.type_category !== undefined){
      fields = fields.concat([
        {
          col: 4,
          type: 'autocomplete',
          name: 'fk_id_company',
          label: language.COMPANY,
          method: 'POST',
          route: `${Constants.APIEndpoints.COMPANY}/filter`,
          fieldquery: 'search',
          textlabel: language.COMPANY,
          textinit: values?.fk_id_company > 0 ? values.namecompany : '',
          fieldvaluedb: 'id_company',
          fieldlabeldb: 'name',
          idinit: values?.fk_id_company > 0 ? values.fk_id_company : null,
          routeAll: `${Constants.APIEndpoints.COMPANY}/all?`,
          methodGetAll: 'POST',
          routeGetCount: `${Constants.APIEndpoints.COMPANY}/count`,
          detail: true,
          required: true,
        },
        {
          col: 4,
          type: 'select',
          name: 'fk_id_contract',
          label: language._CONTRACT,
          options: contracts
            .filter((v) => v.fk_id_out_company == values.fk_id_company || v.fk_id_company == values.fk_id_company)
            .map((c) => ({
              value: c.id_contract,
              label: c.name,
            })),
          required: true,
        },
        {
          col: 4,
          type: 'select',
          name: 'type_tickets',
          label: language.TICKET_TYPE_LABEL,
          options: options.type_tickets(),
          required: true,
        },
        {
          col: 4,
          type: 'select',
          name: 'fk_id_category',
          label: language.CATEGORY,
          options: categoriesOptions
            .filter((c) => c.type_ticket && c.type_ticket.includes(values.type_tickets))
            .map((ctr) => ({ value: ctr.id_category, label: ctr.name })),
          required: true,
        },
        {
          col: 4,
          type: 'select',
          name: 'fk_id_catalog_service',
          label: language.SUBCATEGORY,
          options: catalogOptions,
          required: true,
        },
        {
          col: 4,
          type: 'select',
          name: 'fk_id_catalog_task',
          label: language.TASK,
          options: taskOptions,
          required: true,
        },
        {
          col: 4,
          type: 'autocomplete',
          name: 'fk_id_solicitant',
          label: language.SOLICITANT,
          className: 'tech-group-ticket',
          required: true,
          method: 'POST',
          route: `${Constants.APIEndpoints.USER}/filter`,
          routeGetCount: `${Constants.APIEndpoints.USER}/active/count/all`,
          filterAll: { all_fk_id_company: values.fk_id_company },
          fieldquery: 'search',
          textlabel: language.SOLICITANT,
          textinit:
            values.fk_id_solicitant > 0 ? values.solicitant_name : '',
          fieldvaluedb: 'id_user',
          fieldlabeldb: 'name',
          idinit: values.fk_id_solicitant > 0 ? values.fk_id_solicitant : null,
          routeAll: `${Constants.APIEndpoints.USER}/filter/all?`,
          detail: true,
          methodGetAll: 'POST',
        },
        {
          col: 4,
          type: 'autocomplete',
          name: 'fk_id_tech',
          label: language.TECH,
          className: 'tech-group-ticket',
          required: false,
          method: 'POST',
          route: `${Constants.APIEndpoints.USER}/filter`,
          routeGetCount: `${Constants.APIEndpoints.USER}/active/count/all`,
          filterAll: { all_fk_id_company: values.fk_id_company },
          fieldquery: 'search',
          textlabel: language.TECH,
          textinit: values.fk_id_tech > 0 ? values.tech_name : '',
          fieldvaluedb: 'id_user',
          fieldlabeldb: 'name',
          idinit: values.fk_id_tech > 0 ? values.fk_id_tech : null,
          routeAll: `${Constants.APIEndpoints.USER}/filter/all?`,
          detail: true,
          methodGetAll: 'POST',
        },
        {
          col: 4,
          type: 'check',
          name: 'recurrence',
          label: language.RECURRENCE,
          required: true,
        },
        {
          col: 4,
          type: 'time',
          name: 'time',
          label: language.TIME,
          visible: values.type_category == 'close',
          required: true,
        },
        {
          type: 'textEditor',
          name: 'description_details',
          label: language.DESCRIPTION,
          visible: values.type_category == 'close',
          required: true,
        },
      ]);
    }

    return fields;
  }

  return (
    <Card style={{ overflow: 'visible' }}>
      <AppBar title={language.ACTIONS} />
      <div className="content pt-0">
        <CommonForm
          sensitive
          values={{
            type_tickets: values.type_tickets,
            type_category: values.type_category,
            fk_id_category: values.fk_id_category,
            fk_id_catalog_service: values.fk_id_catalog_service,
            fk_id_catalog_task: values.fk_id_catalog_task,
            fk_id_solicitant: values.fk_id_solicitant,
            fk_id_tech: values.fk_id_tech,
            fk_id_contract: values.fk_id_contract,
            fk_id_company: values.fk_id_company,
            recurrence: values.recurrence,
            time: values.time,
            description_details: values.description_details,
          }}
          onRef={(ref) => setFormReference(ref)}
          fields={loadFields()}
          onChangeField={(f, v) => {

            if (f && f.name == 'type_category') {
              setValue('type_category', v);
            }

            if (f && f.name == 'fk_id_company') {
              setValue('fk_id_company', v);
              getCategoryByCompany(v);
            }

            if (f && f.name == 'fk_id_contract') {
              setValue('fk_id_contract', v);
            }
            
            if (f && f.name == 'type_tickets') {
              setValue('type_tickets', v);
            }

            if (f && f.name == 'fk_id_category'){
              setValue('fk_id_category', v);
              getCatalogByCategory(v)
            }
            
            if (f && f.name == 'fk_id_catalog_service') {
              setValue('fk_id_catalog_service', v);
            }
            
            if (f && f.name == 'fk_id_catalog_task') {
              setValue('fk_id_catalog_task', v);
            }
            
            if (f && f.name == 'fk_id_solicitant') {
              setValue('fk_id_solicitant', v);
            }
            
            if (f && f.name == 'fk_id_tech') {
              setValue('fk_id_tech', v);
            }
            
            if (f && f.name == 'recurrence') {
              setValue('recurrence', v);
            }
            
            if (f && f.name == 'time') {
              setValue('time', v);
            }
            
            if (f && f.name == 'textEditor'){
              setValue('textEditor', v);
            }

            handleValue(v, f.name);
          }}
        />
      </div>
    </Card>
  );
}
